// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kLL9","newExpiryDate":"styles_newExpiryDate__2pC2g","footer":"styles_footer__2eqYX"};